import { BuildingBlockTagTranslationDto } from "../../dto/building-blocks/building-block-tag-translations.dto";
import { BuildingBlockTagTranslation } from "../../models/building-blocks/building-block-tag.model";

export class BuildingBlockTagTranslationMapper {
  public static toModel(dto: BuildingBlockTagTranslationDto): BuildingBlockTagTranslation {
    return {
      languageId: dto.language_id,
      name: dto.name
    }
  }

  public static toDto(dto: BuildingBlockTagTranslation): BuildingBlockTagTranslationDto {
    return {
      language_id: dto.languageId,
      name: dto.name
    }
  }
}